'use es6';

import PropTypes from 'prop-types';
import { memo, useState, useRef, useEffect } from 'react';
import { UNKNOWN } from 'reporting-data/constants/errorTypes';
import store from 'reporting-data/redux/store';
import ErrorMessage from '../components/shared/ErrorMessage';
import compose from '../lib/compose';
import DataDecorator from './decorators/DataDecorator';
import ErrorBoundaryDecorator from './decorators/ErrorBoundaryDecorator';
import { overrideLimitBasedOnReportHeight } from './utils/paginate';
import { TABLE } from 'reporting-data/constants/chartTypes';
import { isEnabledForViz } from './inferLogic/isReportingVizEnabled';
import Report from './inferLogic/Report';
import ReportGenerator from './ReportGenerator';
import { WithUserInfoProvider } from '../components/PlatformReport/UserInfoProvider';
import { WithFiscalYearProvider } from '../components/PlatformReport/FiscalYearProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const GeneratorWithErrorBoundry = compose([ErrorBoundaryDecorator])(ReportGenerator);
const DecoratedReportGenerator = props => {
  return /*#__PURE__*/_jsx(DataDecorator, Object.assign({}, props, {
    Component: GeneratorWithErrorBoundry
  }));
};
const DecoratedPageableReportGenerator = props => {
  const {
    report,
    height
  } = props;
  const [offset, setOffset] = useState(0);
  const prevReport = useRef(report);
  useEffect(() => {
    const nextDimensions = report.getIn(['config', 'dimensions']);
    const currentDimensions = prevReport.current.getIn(['config', 'dimensions']);
    const nextFilters = report.getIn(['config', 'filters']);
    const currentFilters = prevReport.current.getIn(['config', 'filters']);
    const nextSort = report.getIn(['config', 'sort']);
    const currentSort = prevReport.current.getIn(['config', 'sort']);
    if (nextDimensions && !nextDimensions.equals(currentDimensions) || nextFilters && !nextFilters.equals(currentFilters) || nextSort && !nextSort.equals(currentSort)) {
      setOffset(0);
    }
    return () => {
      prevReport.current = report;
    };
  }, [report]);
  const updatedReport = report.get('chartType') === TABLE ? overrideLimitBasedOnReportHeight(report, height).setIn(['config', 'offset'], offset) : report;
  return /*#__PURE__*/_jsx(DecoratedReportGenerator, Object.assign({}, props, {
    offset: offset,
    updateOffset: setOffset,
    report: updatedReport
  }));
};
function ReportResolver(props) {
  const {
    disableReportingVizRender,
    report
  } = props;
  if (!report.get('chartType')) {
    const errorMessage = `[reporting-ui-components] report missing chart type`;
    return /*#__PURE__*/_jsx(ErrorMessage, {
      type: UNKNOWN,
      error: errorMessage
    });
  }
  const enabledForV2 = isEnabledForViz(report) && !disableReportingVizRender;
  return enabledForV2 ? /*#__PURE__*/_jsx(Report, Object.assign({}, props)) : /*#__PURE__*/_jsx(DecoratedPageableReportGenerator, Object.assign({}, props, {
    store: store
  }));
}
ReportResolver.propTypes = {
  report: PropTypes.object,
  disableReportingVizRender: PropTypes.bool,
  inBrowser: PropTypes.bool
};
const ReportResolverWrapper = /*#__PURE__*/memo(WithUserInfoProvider(WithFiscalYearProvider(ReportResolver)));
export default ReportResolverWrapper;
export const __TESTABLE__ = {
  ReportResolver,
  DecoratedPageableReportGenerator
};